const BACKEND_URL = 'http://localhost:3000';
function parseVariations(text) {
    const lines = text.split('\n').filter(line => line.trim());
    const variations = [];
    for (const line of lines) {
        const match = line.match(/^\d+[\.\)\-\:]\s*(.+)$/);
        if (match && match[1]) {
            variations.push(match[1].trim());
        }
    }
    return variations.slice(0, 5);
}
export async function generateTitleVariations(originalTitle) {
    console.log('Calling Claude API via backend...');
    try {
        const response = await fetch(`${BACKEND_URL}/api/claude/generate-titles`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
            },
            body: JSON.stringify({ title: originalTitle }),
        });
        console.log('Claude API response status:', response.status);
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            console.error('Claude API error:', errorData);
            if (response.status === 401) {
                throw new Error('Claude API key is invalid');
            }
            else if (response.status === 429) {
                throw new Error('Claude API rate limit reached. Please wait a moment.');
            }
            else {
                throw new Error(`Claude API error: ${response.status}`);
            }
        }
        const data = await response.json();
        console.log('Claude API data:', data);
        if (!data.content || data.content.length === 0) {
            throw new Error('No response from Claude API');
        }
        const variations = parseVariations(data.content[0].text);
        if (variations.length === 0) {
            throw new Error('Failed to parse title variations from Claude response');
        }
        while (variations.length < 5) {
            variations.push(`${originalTitle} (Variation ${variations.length + 1})`);
        }
        return variations;
    }
    catch (error) {
        console.error('Claude API fetch error:', error);
        if (error instanceof Error) {
            throw error;
        }
        throw new Error('Unable to connect to Claude API. Check your internet connection.');
    }
}
